import { getBillsDetails, deleteBillsDetails } from '@/services/bills.js'
import viewFrame from '@/components/viewFrame'
import history from '@/common/data/jsonData'
import { getHistoryList } from '@/services/resource'
import createTable from '@/components/createTable'
import customeTable from '@/components/customeTable'
import dialogEffect from '@/components/dialogEffect'
import jsonData from './jsonData'
import loading from '@/utils/loading.json'
import Utils from '@/utils/Utils.js'
import { mixin } from '@/mixins/viewDiolog.js'
export default {
  components: {
    createTable,
    viewFrame,
    customeTable,
    dialogEffect
  },
  mixins: [mixin],
  data () {
    return {
      urlParams: null,
      validateVisible: false,
      buttonObj: [],
      titleObject: {
        show: true
      },
      custName: {},
      formData: {},
      modifyData: {},
      type: '',
      basicViewItem: jsonData.basicViewItem,
      customerViewItem: jsonData.customerViewItem,
      orderTableItem: jsonData.orderTableItem,
      paymentHistoryTableItem: jsonData.paymentHistoryTableItem,
      historyTableItem: history.historyTableItem,
      dialogData: [],
      batchData: [],
      dialogVisible: false,
      historyTableData: []
    }
  },
  created () {
    const _this = this
    _this.urlParams = _this.$route.params
  },
  mounted () {
    const _this = this
    _this.init()
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = _this.$loading(loading) : _this.$store.state.app.loading.close()
    },
    // 初始化
    init () {
      const _this = this
      _this.setGlobalLoading(true)
      getBillsDetails(_this.urlParams.id).then(res => {
        _this.setGlobalLoading(false)
        _this.$message({
          type: 'success',
          message: _this.$t('message.loadSuccess')
        })
        const { bill } = res.data
        this.$set(this, 'custName', bill)
        Object.assign(this.titleObject, { title: `${_this.$t('form.bill.bill')} No. `, data: bill.basic_information.bill_no.value })
        if (this.custName.shop_payments && this.custName.shop_payments.length > 0) {
          Object.keys(this.custName.shop_payments[0]).forEach(item => {
            if (item === 'member_actions') return
            const index = this.orderTableItem.findIndex(fditem => fditem.prop === item)
            if (index >= 0) this.orderTableItem[index].label = this.custName.shop_payments[0][item].name
          })
        }
        if (this.custName.payment_history && this.custName.payment_history.length > 0) {
          Object.keys(this.custName.payment_history[0]).forEach(item => {
            if (item === 'member_actions') return
            const index = this.paymentHistoryTableItem.findIndex(fditem => fditem.prop === item)
            if (index >= 0) this.paymentHistoryTableItem[index].label = this.custName.payment_history[0][item].name
          })
        }
      })
      //  获取历史操作
      getHistoryList({ item_type: 'Bill', item_id: _this.urlParams.id }).then(res => {
        if (res.status === 200) {
          this.historyTableData = res.data.versions
        }
      })
    },
    handleBasicInfoForwardToPage (data, name) {
      console.log(data, name)
      if (name === 'user' || name === 'customer_id') {
        this.$router.push({
          name: 'memberDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'shop') {
        this.$router.push({
          name: 'shopsManagerDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    async handleClick (type, data) {
      if (type?.action === 'destroy') {
        this.deleteClick(this.urlParams.id, deleteBillsDetails, 'billsManagerList')
      }
    },
    handleCusClick (item, data) {
      if (item.action === 'view' || item.action === 'edit') {
        this.$router.push({
          name: 'ordersManagerUserOrdersDetail',
          params: {
            id: data.id.value
          }
        })
      } else {
        Utils.custOperate(item, this)
      }
    }
  }
}
